/**
 * Centralna mapa cen FUSION na podstawie oficjalnego cennika
 * Aktualizacja: 30.10.2025
 */

export interface FusionPrice {
  standard?: {
    fusion: number
    modules: number
  }
  lift?: {
    fusion: number
    modules: number
  }
}

export interface FusionCornerPrice {
  standard?: {
    fusion: number
    modules: number
  }
  lift?: {
    fusion: number
    modules: number
  }
}

export const fusionPrices: { [modelId: string]: FusionPrice } = {
  // DRAGON WKŁADY POWIETRZNE - PROSTE
  'dragon-2-slim': {
    standard: { fusion: 5890, modules: 1290 },
    lift: { fusion: 6420, modules: 1440 }
  },
  'dragon-2': {
    standard: { fusion: 5890, modules: 1290 },
    lift: { fusion: 6420, modules: 1440 }
  },
  'dragon-4': {
    standard: { fusion: 6420, modules: 1500 },
    lift: { fusion: 6420, modules: 1440 }
  },
  'dragon-4-slim': {
    standard: { fusion: 6260, modules: 1440 },
    lift: { fusion: 6420, modules: 1440 }
  },
  'dragon-4-xl-slim': {
    standard: { fusion: 6260, modules: 1440 },
    lift: { fusion: 6420, modules: 1440 }
  },
  'dragon-4-xl': {
    standard: { fusion: 6420, modules: 1500 },
    lift: { fusion: 6420, modules: 1440 }
  },
  'dragon-6': {
    standard: { fusion: 6260, modules: 1440 },
    lift: { fusion: 6900, modules: 1570 }
  },
  'dragon-6-xl': {
    standard: { fusion: 6260, modules: 1440 },
    lift: { fusion: 6800, modules: 1570 }
  },
  'dragon-6-xxl': {
    standard: { fusion: 6260, modules: 1440 },
    lift: { fusion: 6900, modules: 1570 }
  },
  'dragon-8': {
    standard: { fusion: 5620, modules: 950 },
    lift: { fusion: 5890, modules: 1570 }
  },
  'dragon-8-xxl': {
    standard: { fusion: 5620, modules: 950 },
    lift: { fusion: 5890, modules: 1570 }
  },
  'dragon-8-mini': {
    standard: { fusion: 5250, modules: 910 },
    lift: { fusion: 5890, modules: 1570 }
  },
  'dragon-8-slim': {
    standard: { fusion: 5250, modules: 910 },
    lift: { fusion: 5890, modules: 1570 }
  },
  'dragon-9': {
    // Brak w cenniku - używam domyślne
    standard: { fusion: 6000, modules: 1200 },
    lift: { fusion: 6500, modules: 1500 }
  },
  'dragon-9-xl': {
    // Brak w cenniku - używam domyślne
    standard: { fusion: 6000, modules: 1200 },
    lift: { fusion: 6500, modules: 1500 }
  },
  'dragon-2-xl': {
    // Brak w cenniku - używam domyślne
    standard: { fusion: 6000, modules: 1300 },
    lift: { fusion: 6500, modules: 1450 }
  },

  // DRAGON WKŁADY POWIETRZNE - NAROŻNE (CORNER)
  'dragon-2b-slim': {
    standard: { fusion: 5890, modules: 1290 },
    lift: { fusion: 6000, modules: 1290 }
  },
  'dragon-2b': {
    standard: { fusion: 5890, modules: 1290 },
    lift: { fusion: 6000, modules: 1290 }
  },
  'dragon-2b-xl': {
    standard: { fusion: 3910, modules: 600 },
    lift: { fusion: 4450, modules: 790 }
  },
  'dragon-2a': {
    standard: { fusion: 5890, modules: 1290 },
    lift: { fusion: 6000, modules: 1290 }
  },
  'dragon-3': {
    standard: { fusion: 5890, modules: 1290 },
    lift: { fusion: 6000, modules: 1290 }
  },
  'dragon-4b-slim': {
    standard: { fusion: 6260, modules: 1440 },
    lift: { fusion: 6420, modules: 1440 }
  },
  'dragon-4b-xl-slim': {
    standard: { fusion: 6260, modules: 1440 },
    lift: { fusion: 6420, modules: 1440 }
  },
  'dragon-4b-xl': {
    standard: { fusion: 6420, modules: 1500 },
    lift: { fusion: 6420, modules: 1440 }
  },
  'dragon-4b': {
    standard: { fusion: 4180, modules: 600 },
    lift: { fusion: 5090, modules: 1010 }
  },
  'dragon-8b': {
    standard: { fusion: 5250, modules: 910 },
    lift: { fusion: 5890, modules: 1570 }
  },
  'dragon-8b-xxl': {
    standard: { fusion: 5520, modules: 910 }
    // Brak wersji lift dla Dragon 8B XXL zgodnie z tabelą
  },
  'dragon-6-corner': {
    standard: { fusion: 6260, modules: 1440 },
    lift: { fusion: 6900, modules: 1570 }
  },
  'dragon-9-corner': {
    standard: { fusion: 6000, modules: 1200 },
    lift: { fusion: 6500, modules: 1500 }
  },

  // DRAGON VIS-A-VIS
  'dragon-2-duo': {
    standard: { fusion: 5890, modules: 1290 },
    lift: { fusion: 6420, modules: 1440 }
  },
  'dragon-8-duo': {
    standard: { fusion: 5620, modules: 950 },
    lift: { fusion: 5890, modules: 1570 }
  },
  'dragon-8-xxl-duo': {
    standard: { fusion: 5620, modules: 950 },
    lift: { fusion: 5890, modules: 1570 }
  },
  'dragon-9-duo': {
    standard: { fusion: 6000, modules: 1200 },
    lift: { fusion: 6500, modules: 1500 }
  },

  // DRAGON AKU
  'dragon-aku-2': {
    standard: { fusion: 5890, modules: 1290 }
  },
  'dragon-aku-2-xl': {
    standard: { fusion: 5890, modules: 1290 }
  },
  'dragon-aku-4-slim': {
    standard: { fusion: 6260, modules: 1440 }
  },
  'dragon-aku-4': {
    standard: { fusion: 6420, modules: 1500 }
  },
  'dragon-aku-6': {
    standard: { fusion: 6260, modules: 1440 }
  },
  'dragon-aku-6-xl': {
    standard: { fusion: 6260, modules: 1440 }
  },
  'dragon-aku-9': {
    standard: { fusion: 6000, modules: 1200 }
  },
  'dragon-aku-8': {
    standard: { fusion: 5250, modules: 910 }
  },
  'dragon-aku-4-duo': {
    standard: { fusion: 6420, modules: 1500 }
  },
  'dragon-aku-8-duo': {
    standard: { fusion: 5250, modules: 910 }
  },
  'dragon-aku-9-duo': {
    standard: { fusion: 6000, modules: 1200 }
  },

  // DRAGON AKU NAROŻNE
  'dragon-aku-2b': {
    standard: { fusion: 5890, modules: 1290 }
  },
  'dragon-aku-2b-xl': {
    standard: { fusion: 5890, modules: 1290 }
  },
  'dragon-aku-4b-slim': {
    standard: { fusion: 6260, modules: 1440 }
  },
  'dragon-aku-4b': {
    standard: { fusion: 6420, modules: 1500 }
  },

  // NEMO WKŁADY WODNE
  'nemo-2': {
    standard: { fusion: 6640, modules: 1500 },
    lift: { fusion: 6800, modules: 1500 }
  },
  'nemo-2-xl': {
    standard: { fusion: 6640, modules: 1500 },
    lift: { fusion: 6800, modules: 1500 }
  },
  'nemo-4-slim': {
    standard: { fusion: 7170, modules: 1710 },
    lift: { fusion: 7330, modules: 1710 }
  },
  'nemo-4': {
    standard: { fusion: 7170, modules: 1710 },
    lift: { fusion: 7330, modules: 1710 }
  },
  'nemo-6': {
    standard: { fusion: 7170, modules: 1710 },
    lift: { fusion: 7330, modules: 1710 }
  },
  'nemo-6-xl': {
    standard: { fusion: 6910, modules: 1640 },
    lift: { fusion: 7070, modules: 1640 }
  },
  'nemo-8': {
    standard: { fusion: 7170, modules: 1710 },
    lift: { fusion: 7330, modules: 1710 }
  },
  'nemo-9': {
    standard: { fusion: 7170, modules: 1710 },
    lift: { fusion: 7330, modules: 1710 }
  },

  // NEMO NAROŻNE
  'nemo-2b': {
    standard: { fusion: 6640, modules: 1500 },
    lift: { fusion: 6800, modules: 1500 }
  },
  'nemo-2b-xl': {
    standard: { fusion: 6640, modules: 1500 },
    lift: { fusion: 6800, modules: 1500 }
  },
  'nemo-4b-slim': {
    standard: { fusion: 7170, modules: 1710 },
    lift: { fusion: 7330, modules: 1710 }
  },
  'nemo-4b': {
    standard: { fusion: 7170, modules: 1710 },
    lift: { fusion: 7330, modules: 1710 }
  },

  // NEMO VIS-A-VIS
  'nemo-2-duo': {
    standard: { fusion: 6540, modules: 1500 },
    lift: { fusion: 6800, modules: 1500 }
  },
  'nemo-4-duo': {
    standard: { fusion: 7190, modules: 1710 },
    lift: { fusion: 7330, modules: 1710 }
  },
  'nemo-8-duo': {
    standard: { fusion: 7190, modules: 1710 },
    lift: { fusion: 7330, modules: 1710 }
  }
}

/**
 * Pobiera ceny fusion dla konkretnego modelu i wariantu
 */
export function getFusionPrices(modelId: string, variant: 'standard' | 'lift' = 'standard'): { fusion: number, modules: number } {
  const modelPrices = fusionPrices[modelId]
  
  if (!modelPrices) {
    console.warn(`Brak cen fusion dla modelu: ${modelId}`)
    return { fusion: 500, modules: 200 } // fallback
  }

  const variantPrices = modelPrices[variant]
  
  if (!variantPrices) {
    // Jeśli nie ma cen dla lift, spróbuj standard
    const fallbackPrices = modelPrices.standard
    if (fallbackPrices) {
      return { fusion: fallbackPrices.fusion, modules: fallbackPrices.modules }
    }
    
    console.warn(`Brak cen fusion dla modelu ${modelId} wariant ${variant}`)
    return { fusion: 500, modules: 200 } // fallback
  }

  return { fusion: variantPrices.fusion, modules: variantPrices.modules }
}

/**
 * Ceny FUSION CORNER na podstawie tabeli z załącznika
 * D = Dragon, N = Nemo
 * Jeśli po slashu jest Lift to dostepny również w wersji lift
 */
export const fusionCornerPrices: { [modelId: string]: FusionCornerPrice } = {
  // DRAGON CORNER MODELS (zgodnie z tabelą UNICO FUSION CORNER)
  'dragon-2b': {
    standard: { fusion: 4550, modules: 910 },
    lift: { fusion: 4710, modules: 910 }
  },
  'dragon-2b-slim': {
    standard: { fusion: 4550, modules: 910 },
    lift: { fusion: 4710, modules: 910 }
  },
  'dragon-4b-slim': {
    standard: { fusion: 4980, modules: 1010 },
    lift: { fusion: 5090, modules: 1010 }
  },
  'dragon-8b': {
    standard: { fusion: 3910, modules: 600 },
    lift: { fusion: 4450, modules: 790 }
  },
  'dragon-8b-xxl': {
    standard: { fusion: 4180, modules: 600 }
    // Brak wersji lift dla Dragon 8B XXL zgodnie z tabelą
  },

  // NEMO CORNER MODELS (zgodnie z tabelą UNICO FUSION CORNER)
  'nemo-2b': {
    standard: { fusion: 5250, modules: 1000 },
    lift: { fusion: 5350, modules: 1050 }
  },
  'nemo-4b': {
    standard: { fusion: 5250, modules: 1280 },
    lift: { fusion: 5350, modules: 1280 }
  },
  'nemo-4b-slim': {
    standard: { fusion: 5250, modules: 1280 },
    lift: { fusion: 5350, modules: 1280 }
  }
}

/**
 * Pobiera ceny fusion corner dla konkretnego modelu i wariantu
 */
export function getFusionCornerPrices(modelId: string, variant: 'standard' | 'lift' = 'standard'): { fusion: number, modules: number } | null {
  const modelPrices = fusionCornerPrices[modelId]
  
  if (!modelPrices) {
    // Nie logujemy ostrzeżenia - po prostu zwracamy null jeśli model nie ma FUSION CORNER
    return null
  }

  const variantPrices = modelPrices[variant]
  
  if (!variantPrices) {
    // Dla FUSION CORNER nie używamy fallback - jeśli nie ma wariantu, to nie ma opcji
    return null
  }

  return { fusion: variantPrices.fusion, modules: variantPrices.modules }
}

/**
 * Sprawdza czy model ma dostepne FUSION CORNER
 */
export function isFusionCornerAvailableForModel(modelId: string, variant: 'standard' | 'lift' = 'standard'): boolean {
  return getFusionCornerPrices(modelId, variant) !== null
}